<template>
  <with-actions>
    <div class="form-inline ml-auto" slot="context-actions">
      <router-link class="btn btn-success" :to="{ name: 'barcode_range_create' }" tag="button">{{
        'routes_barcode_ranges_create' | t
      }}</router-link>
    </div>
    <div class="card">
      <table class="table">
        <thead>
          <tr>
            <th>{{ 'Barcode type' }}</th>
            <th>{{ 'Serial from' }}</th>
            <th>{{ 'Serial to' }}</th>
            <th>{{ 'Barcodes left' }}</th>
            <th>{{ ' ' }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="range in barcode_ranges">
            <td>{{ range.barcode_type }}</td>
            <td>{{ range.serial_from }}</td>
            <td>{{ range.serial_to }}</td>
            <td>{{ range.serial_to - range.current_serial }}</td>
            <td class="text-right">
              <button
                class="btn btn-sm btn-danger"
                @click="deleteRange(range)"
                v-if="range.current_serial === range.serial_from"
              >
                {{ 'Delete' }}
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </with-actions>
</template>
<script>
import Api from '@/store/jsonapi';

export default {
  data: function () {
    return {
      barcode_ranges: []
    };
  },
  methods: {
    deleteRange: function (range) {
      if (!confirm('Will you delete this range? It CANNOT be recovered!')) {
        return;
      }
      Api.destroy('barcode_ranges', range.id).then(({ data }) => {
        Alerts.success({ title: 'Range was deleted', detail: '' });
        this.load();
      });
    },
    load: function () {
      Api.findAll('barcode_ranges').then(({ data }) => {
        this.barcode_ranges = data;
      });
    }
  },
  mounted: function () {
    this.setBreadcrumbs([{ to: { name: 'barcode_ranges' }, text: 'Global barcode ranges' }]);
    this.load();
  }
};
</script>

<style scoped></style>
